import type { ComponentType } from 'react';
import type { PopupViewKey } from '@/lib/notifications/popup-view';
import type { PopupViewProps } from './types';
import { GenericPopup } from './views/GenericPopup';
import { LimitOrderExpiredPopup } from './views/LimitOrderExpiredPopup';
import { MarketClosingSoonPopup } from './views/MarketClosingSoonPopup';
import { NewMarketPopup } from './views/NewMarketPopup';
import { OrderFilledPartialPopup } from './views/OrderFilledPartialPopup';
import { OrderFilledPopup } from './views/OrderFilledPopup';
import { PositionValueChangePopup } from './views/PositionValueChangePopup';
import { ResolutionNonePopup } from './views/ResolutionNonePopup';
import { ResolutionWonAllPopup } from './views/ResolutionWonAllPopup';
import { ResolutionWonSomePopup } from './views/ResolutionWonSomePopup';
import { WithdrawApprovedPopup } from './views/WithdrawApprovedPopup';
import { WithdrawFailedPopup } from './views/WithdrawFailedPopup';

/**
 * The pop-up view for each resolved {@link PopupViewKey}. Every one of the 11
 * PRD keys (+ resolution outcomes / partial fill) is pre-registered here; three
 * are built fully to Figma (order-filled, resolution-won-some,
 * market-closing-soon) and the rest are stubs a follow-up pass fills in place —
 * without touching this map. `generic` is the catch-all template for the
 * non-PRD types.
 */
export const POPUP_VIEWS: Record<PopupViewKey, ComponentType<PopupViewProps>> = {
  'withdrawal-approved': WithdrawApprovedPopup,
  'withdrawal-failed': WithdrawFailedPopup,
  'resolution-won-all': ResolutionWonAllPopup,
  'resolution-won-some': ResolutionWonSomePopup,
  'resolution-none': ResolutionNonePopup,
  'position-value-change': PositionValueChangePopup,
  'order-filled': OrderFilledPopup,
  'order-filled-partial': OrderFilledPartialPopup,
  'new-market': NewMarketPopup,
  'limit-order-expired': LimitOrderExpiredPopup,
  'market-closing-soon': MarketClosingSoonPopup,
  generic: GenericPopup,
};
